import React from 'react';

import useFabletics from '../../hooks/useFabletics';
import FableticsUpgradeMember from './FableticsUpgradeMember';
import FableticsUpgradeUpsell from './FableticsUpgradeUpsell';

// Visual creative for the Fabletics upgrade flow. Caller (the popup that hosts
// this) decides whether to render this at all; this component just picks the
// creative for the resolved audience. No CTA, no form — those belong to the popup.
const FableticsUpgradeCreative = () => {
    const { isUpsellAudience } = useFabletics();
    const CreativeComponent = isUpsellAudience ? FableticsUpgradeUpsell : FableticsUpgradeMember;
    return <CreativeComponent />;
};

export default FableticsUpgradeCreative;
